const onOpenBrochure = (_url) => {
  try {
    if (window.cordova) {
      window.ktwebview.open(
        _url,
        function(response) {
          console.log('ktwebview response')
        },
        function(error) {
          console.log('ktwebview error')
        }
      )
    } else {
      window.open(_url)
    }
  } catch (e) {
    console.log('open brochure', e)
  }
}

export { onOpenBrochure }
